import {BasisType, Goal, PackageTemplate, Partner, Service, type INormalize} from "@raskrask-dk/raskrask-utils";
import type { IGoalDTO, IPackageDTO, IPartnerDTO, IServiceDTO} from "..";

export type MapById<T extends {id: string | number}> = Map<T["id"], T>;

export interface DomainClasses {
  goal: (dto: IGoalDTO) => Goal;
  service: (dto: IServiceDTO) => Service;
  partner: (dto: IPartnerDTO) => Partner;
  packageTemplate: (dto: IPackageDTO, service: Service) => PackageTemplate;
}

export const defaultMappers: DomainClasses = {
  service: (serviceDTO: IServiceDTO): Service => {
    const service = new Service(
      serviceDTO.id,
      serviceDTO.name,
      30, // TODO
      false // TODO
    );
    if (serviceDTO?.goal?.id) {
      const goal = new Goal(serviceDTO.goal.id, serviceDTO.goal.name);
      goal.addBasisTypeId(serviceDTO.goal.basisTypeId);
      service.addGoal(goal);
    }
    return service;
  },
  partner: (partnerDTO: IPartnerDTO): Partner => new Partner(partnerDTO.id, partnerDTO.name),
  goal: (goalDTO: IGoalDTO): Goal => new Goal(goalDTO.id, goalDTO.name),
  packageTemplate: (packageDTO: IPackageDTO, service: Service): PackageTemplate => {
    const {id, name, multiplier, discount} = packageDTO;
    return new PackageTemplate(service, id, name, multiplier, discount);
  },
};

export interface DomainMapper<DomainClass extends {id: string | number}, DTOModel> {
  fromDTO(dto: DTOModel): DomainClass;
  toDTO(domainClass: DomainClass): DTOModel;
  fromNormalized(dto: INormalize<DTOModel>, basisType?: BasisType): MapById<DomainClass>;
}

export type IdValTuple<T extends {id: string | number}> = [id: T["id"], dto: T];
